// Types
import { Icon as IconType } from '../../../types/icon';
import { Measurements } from '../../../types/measurements';

// Utils
import { getMeasurementBySize } from '../../../utils/icon';

// Component
import Icon from '../Icon/Icon';

const IconTightArrow = (props: IconType) => {
  const {
    size,
    inverse,
    onClick,
    width,
    height,
    fill,
    iconClassName,
  } = props;

  const defaultMeasurements: Measurements = {
    height: 10,
    width: 6,
  }

  const measurements = size ? getMeasurementBySize(size) : defaultMeasurements;

  return (
    <Icon inverse={inverse} onClick={onClick} className={iconClassName} classNameIconType="c-icon-tight-arrow">
      <svg width={width || measurements.width} height={height || measurements.height} className="c-icon-tight-arrow fill-current" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4.87598 6.15137L5.51562 6.81055L2.99512 9.33105L0.484375 6.81055L1.15332 6.15137L2.53613 7.53906V0.668945H3.46387V7.53906L4.87598 6.15137Z" fill={fill || '#FF892E'} />
      </svg>

    </Icon>
  );
};

export default IconTightArrow;
